const getProjectId = (schemaPath: string): string => {
  // Remove trailing slashes
  if (schemaPath.endsWith('/') || schemaPath.endsWith('\\')) {
    schemaPath = schemaPath.slice(0, -1)
  }

  // Remove leading slashes
  if (schemaPath.startsWith('/') || schemaPath.startsWith('\\')) {
    schemaPath = schemaPath.slice(1)
  }

  return schemaPath.replace(RegExp(/\/|\\/, 'gi'), '-')
}

export default getProjectId
